import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YesNoInput from '../YesNoInput';
import './YesNoInputGroup.scss';

const valueForOption = (option, value) => {
  const optionValue = value && value.find((v) => v.id === option.id);
  return optionValue && optionValue.selected;
};

const error = (formKey, id, errors) => (
  (errors && errors[`${formKey}_${id}`] === 'radio_button')
);

const hasErrors = (formKey, options, errors) => {
  if (options.length > 0 && Object.entries(errors).length > 0) {
    return (options.some((option) => errors[`${formKey}_${option.id}`] === 'radio_button'));
  }
  return false;
};

const requiredError = (formKey, options, errors) => {
  if (hasErrors(formKey, options, errors)) {
    return (
      <div className="body-text-2 with-error-text mt-2 mb-2">
        <i className="fa fa-exclamation-triangle" />
        {' '}
        Required!
      </div>
    );
  }
  return null;
};

class YesNoInputGroup extends Component {
  constructor(props) {
    super(props);
    this.onYesNoChange = this.onYesNoChange.bind(this);
  }

  onYesNoChange(option, val) {
    const { value, onAnswerChange } = this.props;
    // Remove and replace any selection for this option
    const newValue = value.filter((v) => v.id !== option.id);
    onAnswerChange([...newValue, { id: option.id, selected: val }]);
  }

  render() {
    const {
      formKey,
      options,
      value,
      errors,
      showIndex,
    } = this.props;

    return (
      <div className="yes-no-input-group body-text-2">
        {requiredError(formKey, options, errors)}
        {
          options.map((option, index) => (
            <div key={option.id}>
              <div className="option-container">
                <span className={error(formKey, option.id, errors) ? 'with-error-text' : ''}>
                  {showIndex ? `${index + 1}. ` : ''}
                  { option.name || option.description }
                </span>
                <YesNoInput
                  className="yes-no-container"
                  id={formKey + option.id}
                  onAnswerChange={(val) => this.onYesNoChange(option, val)}
                  value={valueForOption(option, value)}
                  labelError={error(formKey, option.id, errors)}
                />
              </div>
            </div>
          ))
        }
      </div>
    );
  }
}

YesNoInputGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    selected: PropTypes.oneOf(['Yes', 'No']),
  })),
  onAnswerChange: PropTypes.func.isRequired,
  formKey: PropTypes.string.isRequired,
  errors: PropTypes.shape({}),
  showIndex: PropTypes.bool,
};

YesNoInputGroup.defaultProps = {
  value: [],
  errors: {},
  showIndex: false,
};

export default YesNoInputGroup;
